<template>
  <div class="my-4">
    <v-text-field
      light
      label="Title"
      v-model="item.title"
      type="text"
      required
      color="amber"
      placeholder="Name"
      class="my-10"
    ></v-text-field>
    <v-textarea
      light
      label="In a sentence"
      v-model="item.sentence"
      type="text"
      required
      color="amber"
      :rows="2"
      placeholder="Name"
      class="my-10"
      :autoGrow="true"
      :hide-details="true"
    ></v-textarea>

    <v-select
      light
      :items="colors"
      label="Colour code"
      :value="item.color"
      v-model.trim="item.color"
      item-text="title"
      item-value="color"
      class="mr-4 mt-8"
    ></v-select>

    <v-textarea
      light
      label="Context"
      v-model="item.body"
      type="text"
      required
      color="amber"
      placeholder="Description"
      :rows="3"
    ></v-textarea>

    <div class="d-flex justify-end align-center pr-3">
      <v-btn @click="submit" small color="amber" class="my-4" light
        >Change</v-btn
      >
    </div>
  </div>
</template>

<script>
import { colors } from "./model";
export default {
  name: "OfferLogicColForm",
  props: {
    newItem: {
      type: Object,
      default: () => {},
    },
    local: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      item: this.newItem,
      colors: colors,
    };
  },
  methods: {
    submit() {
      this.$emit("update", this.item);
      this.$set(this.item, {});
    },
  },
};
</script>
